<img src="./assets/media/svg/icons/General/Edit-3.svg" (click)="invokeParentMethod()">

&nbsp;

<img src="./assets/media/svg/icons/General/Plus.svg" (click)="invokeAddPositionMethod()" >
